export default {
      id: "yandex_logo-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svgsprite.svg#yandex_logo",
      toString: function () {
        return this.url;
      }
    }